@if (person()) {
  <div class="menu-button" [matMenuTriggerFor]="menu" *transloco="let t">
    @if (!hasPhoto()) {
      <div class="menu-spinner">
        <span class="spinner-border esqep-loading-spinner-medium"></span>
      </div>
    } @else if (personPhotoUrl()) {
      <div class="photo-wrapper">
        <img [src]="personPhotoUrl()" alt="user photo" class="user-photo" />
      </div>
    } @else {
      <div class="no-photo">
        {{ person().givenName.charAt(0) | uppercase }}
        {{ person().familyName.charAt(0) | uppercase }}
      </div>
    }

    <mat-menu #menu="matMenu" yPosition="below">
      <div class="person-details">
        <mat-icon svgIcon="sqep:person" />
        <span> {{ person().givenName }} {{ person().familyName }} </span>
      </div>
      @if (person().adUpn) {
        <div class="person-email">
          <mat-icon svgIcon="sqep:email" />
          <span>{{ person().adUpn }}</span>
        </div>
      }
      <div class="my-details">
        <button mat-menu-item (click)="myDetails()">
          <mat-icon svgIcon="sqep:manage-accounts" />
          <span>{{ t('personDetails.my_details') }}</span>
        </button>
      </div>
      <div class="person-logout">
        <button mat-menu-item (click)="logout()">
          <mat-icon svgIcon="sqep:logout" />
          <span>Logout</span>
        </button>
      </div>
    </mat-menu>
  </div>
}

<!-- commented out until we need to select a language  -->
<!-- <select class="form-select" #lang (change)="changeLang(lang.value)">
        <option *ngFor="let lang of availableLangs" [value]="lang.id">
          {{ lang.label }}
        </option>
      </select> -->
